<template>
    <div class="dynamic-content">
        <div v-if="!loaded">
            <loading-indicator message='Retrieving order status' v-if="!loaded"></loading-indicator>
    
        </div>
        <div v-if="loaded">
            <div v-if="!found">
                <h1>Not Found</h1>
                <div class="row ">
                    <div class="columns small-12 header-margin">
                        <p>
                            No results found. Please check it one more time. If you still get an error, please email our support team at
                            <a :href="'mailto:' + supportEmail + 'subject=Invalid redemption code'">{{supportEmail}}</a>
                        </p>
                    </div>
                </div>
            </div>
            <div v-if="found">
                <h1>Order Status</h1>
                <div class="row text-left keyword-label">Search keyword: 
                    <i><b>{{this.code}}</b></i>
                </div>
                <br style="margin: 20px;">

                
                <div class="row" v-for="(item, index) in listItems" :key="index"> 
                    <h3 class="order-number" v-on:click="getCouponStatus(item, index);" :class="{ 'bottom-border': ((index + 1) === orderNumbers.length) && !item.isOpened }">{{item.orderNumber}}
                        <img v-if="item.isLoading" alt="loading" class="ord-icon" src="/images/loading.gif" style="margin-right: 4px"/>
                        <img v-if="!item.isLoading" alt="loading" class="ord-icon" :class="{ 'rotate': item.isOpened }" style="height:30px;width:30px" src="/images/chevron-down.png"/>
                    </h3>
                    <transition name="slide">
                        <div v-if="item.isOpened" :class="{ 'bottom-border': ((index + 1) === orderNumbers.length) }">
                            <div style="margin-left: 20px">
                                <div class="row" style="padding-top: 20px">
                                    <div class="columns small-12 medium-4 text-left">
                                        Redemption code:
                                    </div>
                                    <div class="columns small-12 medium-4 text-left end">
                                        <strong>{{item.couponCode}} </strong>
                                    </div>
                    
                                </div>
                                <div class="row">
                                    <div class="columns small-12 medium-4 text-left">
                                        Confirmation Number:
                                    </div>
                                    <div class="columns small-12 medium-4 text-left end">
                                        <strong>{{item.confirmationNumber}} </strong>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="columns small-12 medium-4 text-left">
                                        Order Submitted:
                                    </div>
                                    <div class="columns small-12 medium-4 text-left end">
                                        <strong>{{formatDateTime(item.redeemedOn)}} </strong>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="columns small-12 medium-4 text-left">
                                        Name:
                                    </div>
                                    <div class="columns small-12 medium-4 text-left end" style="text-transform: capitalize">
                                        {{item.name}}
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="columns small-12 medium-4 text-left">
                                        Support Phone Number:
                                    </div>
                                    <div class="columns small-12 medium-4 text-left end">
                                        <span v-if="item.supportPhoneNumber">{{item.supportPhoneNumber}}</span> 
                                        <span v-else>N/A</span>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="columns small-12 medium-4 text-left">
                                        Support Email Address:
                                    </div>
                                    <div class="columns small-12 medium-4 text-left end">
                                        <span v-if="item.supportEmailAddress">{{item.supportEmailAddress}}</span> 
                                        <span v-else>N/A</span>
                                    </div>
                                </div>
                                <div class="row">
                                    <br>
                                </div>
                    
                                <div class="row" style="margin-bottom: 10px">
                                    <div class="columns small-12 medium-4 text-left">
                                        Status Details:
                                    </div>
                                    <div class="columns small-6 medium-3  text-left">
                                        <p>{{formatDate(item.redeemedOn) }}</p>
                                    </div>
                                    <div class="columns small-6 medium-5 text-left end">
                                        <p v-if="item.redeemedOn">Order Submitted</p>
                                    </div>
                                </div>
                                <div class="row" v-for="(status, index) in item.status.orderStatus" :key="index">
                                    <div class="columns small-6 medium-3 medium-offset-4 text-left">
                                        <p v-if="status.statusTime">{{formatDate(status.statusTime) }}</p>
                                    </div>
                                    <div class="columns small-6 medium-5 text-left end">
                                        <p> {{status.description}}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </transition>
                </div>

    
                <!--<div class="row">
                    <p class="status-smalltext">
                        Have additional questions about the status of your order? 
                    </p>
                </div>-->
            </div>
            <div class="row">
                <p class="status-smalltext">
                    <router-link class="btn btn-submit coupon_button" to="/status">CHECK ANOTHER ORDER</router-link>
                </p>
            </div>
    
        </div>
    </div>
</template>
<script>

import LoadingIndicator from "@/components/layout/LoadingIndicator";


function convertUTCDateToLocalDate(date) {
    var newDate = new Date(date.getTime() + date.getTimezoneOffset() * 60 * 1000);

    var offset = date.getTimezoneOffset() / 60;
    var hours = date.getHours();

    newDate.setHours(hours - offset);

    return newDate;
}


export default {
    components: { LoadingIndicator },
    props: ["code"],
    data() {
        return {
            loaded: false,
            found: false,
            isLoading: false,
            coupon: null,
            orderNumbers: [],
            lineItem: {
                orderNumber: null,
                isOpened: false,
                couponCode: null
            },
            listItems: []
        }
    },
    methods: {
        formatDateTime(date) {
            if (date) {
                var d = convertUTCDateToLocalDate(new Date(date));
                return d.toLocaleDateString() + " " + d.toLocaleTimeString();
            }

            return "Not submitted";
        },
        formatDate(date) {
            if (date) {
                var d = convertUTCDateToLocalDate(new Date(date));
                return d.toLocaleDateString();
            }

            return "";


        },
        handleError() {
            this.$router.replace("/error/");
        },
        async getCouponStatus(coupon, index) {
            if(coupon.isOpened === false) {
                if(coupon.couponCode != null){
                    coupon.isOpened = !coupon.isOpened;
                }
                else {
                    coupon.isLoading = true;
                    await axios.get('/status/' + coupon.orderNumber)
                        .then(response => {
                            console.log(response);
                            // Fill 
                            coupon.isOpened = !coupon.isOpened;
                            coupon.couponCode = response.data.couponCode;
                            coupon.confirmationNumber = response.data.confirmationNumber;
                            coupon.redeemedOn = response.data.redeemedOn;
                            coupon.status = response.data.status;
                            coupon.name = response.data.rxFirstName + ' ' + response.data.rxLastName;
                            coupon.supportPhoneNumber = response.data.supportPhoneNumber;
                            coupon.supportEmailAddress = response.data.supportEmailAddress;
                            
                            coupon.isLoading = false;
                        }).catch((error) => {
                            if (error.response && error.response.status == 404) {
                                coupon.isLoading = false;
                            }
                            else {
                                this.handleError(error);
                            }
                        });
                }
            }
            else {
                coupon.isOpened = false;
            }
        },
        getStatusList() {
            axios.get('/status/list/' + this.code) // Search field = this.code
            .then(response => {
                this.orderNumbers = response.data;
                this.orderNumbers.forEach(item => {
                    this.lineItem = { orderNumber: item, isOpened: false, isLoading: false, couponCode: null }
                    this.listItems.push(this.lineItem)
                });
                if(this.listItems.length == 0)
                    this.found = false;
                else 
                    this.found = true;
                this.loaded = true;
            }).catch((error) => {
                if (error.response && error.response.status == 404) {
                        this.found = false;
                        this.loaded = true;
                    }
                    else {
                        console.log(error);
                        this.handleError(error);
                    }
            });
        }
    },

    async created() {
        await this.getStatusList();
    },
    computed: {
        supportEmail(){
            // debugger;
           var email = this.coupon && this.coupon.programDetails && this.coupon.programDetails.supportEmailAddress;

           return email || "NPLEsupport@essilorusa.com" ;
        }
    }
}
</script>
<style>
.status-smalltext {
    font-size: 10pt;
    padding-top: 50px;
}
.keyword-label {
    font-size: 14px;
    padding-top: 20px;
}
.order-number {
    border-top: #0000b7 3px solid;
    padding: 10px;
    padding-left: 20px;
    color: #0000b7;
    background: #d2f1ff;
    text-align: left;
    margin: 0;
}
.bottom-border {
    border-bottom: #0000b7 3px solid;
}

.ord-icon {
    height: 30px;
    float: right;
    -webkit-transition: transform 1s; /* Safari */
    transition: transform 1s;
}

.rotate {
    transform: rotate(180deg);   
}

.ord-container {
  -webkit-transition: opacity 600ms, visibility 600ms;
  transition: opacity 600ms, visibility 600ms;
}

.slide-enter-active {
   -moz-transition-duration: 0.3s;
   -webkit-transition-duration: 0.3s;
   -o-transition-duration: 0.3s;
   transition-duration: 0.3s;
   -moz-transition-timing-function: ease-in;
   -webkit-transition-timing-function: ease-in;
   -o-transition-timing-function: ease-in;
   transition-timing-function: ease-in;
}

.slide-leave-active {
   -moz-transition-duration: 0.3s;
   -webkit-transition-duration: 0.3s;
   -o-transition-duration: 0.3s;
   transition-duration: 0.3s;
   -moz-transition-timing-function: cubic-bezier(0, 1, 0.5, 1);
   -webkit-transition-timing-function: cubic-bezier(0, 1, 0.5, 1);
   -o-transition-timing-function: cubic-bezier(0, 1, 0.5, 1);
   transition-timing-function: cubic-bezier(0, 1, 0.5, 1);
}

.slide-enter-to, .slide-leave {
   max-height: 208px;
   overflow: hidden;
}

.slide-enter, .slide-leave-to {
   overflow: hidden;
   max-height: 0;
}
</style>
